module.exports = __webpack_public_path__ + "static/4-3bf73a3e2fde70f261ad1c18df6bb5e9.png";